import {h, Component} from 'preact'
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import constants from '../constants'

import Renderer from '../canvas/renderer'

import MultiAlignWidget from './MultiAlignWidget'
import { UnlockOutlined, LockOutlined, DeleteOutlined } from "@ant-design/icons";
import PositionTools from './PositionTools';

export default @connect(reduce, actions)
class GroupBar extends Component {
    constructor() {
        super()

        this.ungroup = (ev) => {
            Renderer.ungroup(this.props.$element)
        }

        this.remove = (ev) => {
            Renderer.removeElements([this.props.$element])
        }
        this.copyGroup = () => {
            Renderer.copy(this.props.$element)
        }

        this.toggleLock = () => {
            if (this.props.isLocked) {
                Renderer.unlock(this.props.$element)
            } else {
                Renderer.lock(this.props.$element)
            }
            this.props.updateElementAttribute('isLocked', !this.props.isLocked)
        }
    }

    render (props, state) {

        const elementOptions = !props.isLocked ?
            <ul class="secondary">
                <li>
                    <a className="icn rwd-icon ungroup-btn" onClick={this.ungroup}>
                        <span>Ungroup</span>
                    </a>
                </li>
                <li>
                    <PositionTools />
                </li>
                <li>
                    <a className="icn rwd-icon hint--bottom" data-hint="Duplicate" onClick={this.copyGroup}><span>Copy</span><svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-copy" }/></svg></a>
                </li>
                <li>
                    <a class="icn rwd-icon hint--bottom" data-hint="Lock" onClick={this.toggleLock}>
                        <UnlockOutlined />
                    </a>
                </li>
                <li>
                    <a className="rwd-icon hint--bottom" data-hint="Delete" onClick={this.remove}><DeleteOutlined /></a>
                </li>
            </ul>
            :
            <ul class="secondary">
                <li>
                    <a class="icn tgl act rwd-icon hint--bottom" data-hint="Unlock" onClick={this.toggleLock}>
                        <LockOutlined />
                    </a>
                </li>
                <li>
                    <a class="locked-label hint--bottom" data-hint="Unlock" onClick={this.toggleLock}>Locked</a>
                </li>
            </ul>



        return (
            <div class="context-bar">
                {elementOptions}
            </div>
        )
    }
}
